// src/components/ESGSection.jsx
import React from "react";
import CountUp from "./CountUpCircle.jsx";
// import ESGCard from "./ESGCard.jsx";
import CountUpCircle from "./CountUpCircle.jsx";

const ESGSection = ({ company }) => {
  const scores = [
    // { label: "Average Scores of Each Company", value: company.AverageScoresofEachCompany },
    { label: "Anti-Corruption Programmes", value: company.AntiCorruptionProgrammes },
    { label: "Organisational Transparency", value: company.OrganisationalTransparency },
    { label: "Domestic Financial Reporting", value: company.DomesticFinancialReporting },
    { label: "Gender And Non Discrimination Policies", value: company.GenderAndNonDiscriminationPolicies },
    { label: "Human Rights And Corporate Responsibility", value: company.HumanRightsAndCorporateResponsibility },
  ];

  return (
    

<div className="esg-section">
  {/* Bada Average Score */}
  <div className="overall-score">
    <CountUpCircle value={company.AverageScoresofEachCompany} size={150} duration={3000} />
    <div style={{ marginTop: 12, fontWeight: "bold", fontSize: "18px" , textAlign: "center" }}>
      Over All Average Score
    </div>
  </div>

  {/* Small scores */}
  <div className="esg-row">
    {scores.map((s) => (
      <div key={s.label} className="esg-card">
        <CountUpCircle value={s.value} size={100} duration={1500} />
        <div style={{ marginTop: 8 }}>{s.label}</div>
      </div>
    ))}
  </div>
</div>
  );
};

export default ESGSection;